import {CommonScenario} from './CommonScenario';
import {HemisphereLight} from '../HemisphereLight';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';

declare const THREE: any;

export class Beach extends CommonScenario {

  protected createHemisphereLight(): HemisphereLight {
    return new HemisphereLight(
      new ColorInterpolation(
        new THREE.Color(0xf1ffff),
        new THREE.Color(.6, .6, .6)
      ),
      new ColorInterpolation(
        new THREE.Color(0x878252),
        new THREE.Color(.1, .1, .1)
      ),
      1
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/Beach.ts